import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewContainerRef, ViewChildren, QueryList } from '@angular/core';
import { BaseComponent } from '../../base-component';
import { EventService } from '../../service/event.service';
import { Router } from '@angular/router';
import { ChangeNavigationEvent, ValidateAndNavigateEvent, ProgressBarEvent, SkipToMainContentEvent } from '../../service/events';
import { AFDisclosure } from '../../model/af.model';
import { AuthService } from '../../service/auth.service';
import { ConsentService } from '../../service/consent.service';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { CustomValidatorsService } from '../../service/custom-validators.service';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ous-acknowledgement',
  templateUrl: './ous-acknowledgement.component.html',
  styleUrls: ['./ous-acknowledgement.component.scss'],
  standalone: false
})
export class OusAcknowledgementComponent extends BaseComponent implements OnInit, AfterViewInit {

  signatureImg: string; // @Input wet-signature
  ackData: UntypedFormGroup;
  afDisclosureInfo: AFDisclosure;
  authLanguageLookup: string;
  ackTerms: string;
  date: any;
  termDate: any;
  check: boolean = false;
  checkTwo: boolean = false;
  checkCHNCookies: boolean = false;
  checkCHNPDDisc: boolean = false;
  checkCHNThirdDisc: boolean = false;
  checkCHNTransferDisc: boolean = false;
  sigCheckValue: boolean = false;
  jobCountry: string = "";
  termsCheck: boolean = false;
  hasBeenSubmitted: boolean = false;

  @ViewChild("printSection") consentSection: ElementRef;
  @ViewChildren('printSection', { read: ViewContainerRef }) viewContainerRefs: QueryList<any>;
  @ViewChild("pdfButton") pdfButton: ElementRef;

  regexName: RegExp = /^[A-Za-z\u00C0-\u017F\-',. ]+$/;

  constructor(private eventBus: EventService, private _router: Router, private userService: AuthService,
    private consentService: ConsentService, private fb: UntypedFormBuilder, private customValidator: CustomValidatorsService,
    private datepipe: DatePipe, private _snackBar: MatSnackBar) {
    super(eventBus, _router);
  }

  ngOnInit(): void {
    this.jobCountry = this.userService.getJobCountry();
    this.createGroup();
    this.subscribeEvents();
  }

  get output() { return this.ackData.get('output') }
  get legalRequirementsMet() { return this.ackData.get('legalRequirementsMet') }
  get applicantSignedName() { return this.ackData.get('applicantSignedName') }
  get discTermsCheck() { return this.ackData.get('discTermsCheck') }
  get chnCookiesDisc() { return this.ackData.get('chnCookiesDisc') }
  get chnPDDisc() { return this.ackData.get('chnPDDisc') }
  get chnThirdDisc() { return this.ackData.get('chnThirdDisc') }
  get chnTransferDisc() { return this.ackData.get('chnTransferDisc') }
  get bookmarkUrl() { return this.ackData.get('bookmarkUrl') }

  createGroup() {
    if (this.jobCountry !== "CHN") {
      this.ackData = this.fb.group({
        output: ['', Validators.required],
        applicantSignedName: ['', [Validators.required, Validators.maxLength(250), this.customValidator.validateRequiredField, Validators.pattern(this.regexName)]],
        legalRequirementsMet: ['', Validators.requiredTrue],
        discTermsCheck: ['', Validators.requiredTrue],
        chnCookiesDisc: [''],
        chnPDDisc: [''],
        chnThirdDisc: [''],
        chnTransferDisc: [''],
        bookmarkUrl: ['']
      });
    } else {
      this.ackData = this.fb.group({
        output: ['', Validators.required],
        applicantSignedName: ['', [Validators.required, Validators.maxLength(250), this.customValidator.validateRequiredField]],
        legalRequirementsMet: ['', Validators.requiredTrue],
        discTermsCheck: [''],
        chnCookiesDisc: ['', Validators.requiredTrue],
        chnPDDisc: ['', Validators.requiredTrue],
        chnThirdDisc: ['', Validators.requiredTrue],
        chnTransferDisc: ['', Validators.requiredTrue],
        bookmarkUrl: ['']
      });
    }
  }

  subscribeEvents() {
    this.consentService.getAfDisclosure().subscribe((data: AFDisclosure) => {
      this.afDisclosureInfo = data;
      this.ackData.patchValue(data);
      this.authLanguageLookup = data.authLanguageLookup;
      this.signatureImg = data.output;
      this.date = data.legalRequirementCheckDate;
      this.termDate = data.discTermsCheckDate;
      this.setLanguage();
    });

    this.legalRequirementsMet.valueChanges.subscribe(() => {
      this.setDate();
    });

    this.discTermsCheck.valueChanges.subscribe(() => {
      this.setTermDate();
    });

    if (this.jobCountry === "CHN") {
      this.chnCookiesDisc.valueChanges.subscribe(() => {
        this.setTermDateCHN();
      });

      this.chnPDDisc.valueChanges.subscribe(() => {
        this.setTermDateCHN();
      });

      this.chnThirdDisc.valueChanges.subscribe(() => {
        this.setTermDateCHN();
      });

      this.chnTransferDisc.valueChanges.subscribe(() => {
        this.setTermDateCHN();
      });
    }

    this.sub = this.eventBus.on(
      ValidateAndNavigateEvent,
      (event): void => {
        this.bookmarkUrl.setValue("");
        if (event.payload.currentLink === '/ous-acknowledgement') {
          this.bookmarkUrl.setValue("");
          if (event.payload.save) {
            this.submitafDisclosureInfo((this.ackData.value), event);
          } else if (event.payload.saveAndFinishLater) {
            this.bookmarkUrl.setValue(event.payload.currentLink);
            this.submitafDisclosureInfo((this.ackData.value), event);
          } else if (this.validate()) {
            this.submitafDisclosureInfo((this.ackData.value), event);
          }
        }
      }
    );
  }

  ngAfterViewInit() {
    this.ackData.valueChanges.subscribe(() => {
      setTimeout(() => {
        let progress = this.getPercentage(this.ackData);
        this.eventBus.emit(new ProgressBarEvent({ id: progress }));
      }, 100);
    });

    // retain navigation on page refresh
    let navlink = this.userService.getNavLinks().find(e => e.routerLink === "/ous-acknowledgement");
    this.eventBus.emit(new ChangeNavigationEvent({ id: navlink.id }));

    this.viewContainerRefs.changes.subscribe(() => {
      if (this.viewContainerRefs.toArray().length) {
        if (this.consentSection) {
          const underlinNodes: NodeListOf<HTMLElement> = this.consentSection.nativeElement.querySelectorAll('u');
          const underlines: HTMLElement[] = Array.from(underlinNodes);
          underlines.forEach((underline: HTMLElement) => { //use underline tags to jump to Appendix A of document 
            underline.addEventListener('click', this.scrollToAppendixA);
          })
        }
      }
    });
  }

  setLanguage() {
    this.ackTerms = this.afDisclosureInfo.languageLookup['ACKNOWLDGMENT_TERMS'];
  }

  downloadAcknowledgmentPDF(): void {
    let fileName = "Acknowledgment of Consent";
    this.userService.downloadAcknowledgmentPDF(fileName, this.userService.getJobCountry(), this.userService.getJobSubCountry(), this.userService.getAfId()).subscribe({
      next: () => {
        this.termsCheck = true;
      },
      error: (error: Error) => {
        this.termsCheck = false;
        console.log("Error with downloading PDF: ", error);
      }
    });
  }

  submitafDisclosureInfo(afDisclosureInfo: AFDisclosure, event) {
    afDisclosureInfo.output = this.signatureImg;
    afDisclosureInfo.afId = this.userService.getAfId();
    afDisclosureInfo.legalRequirementCheckDate = this.date;
    afDisclosureInfo.discTermsCheckDate = this.termDate;
    afDisclosureInfo.discStatsCheckDate = this.termDate;

    this.consentService.saveAfDisclosure(afDisclosureInfo).subscribe({
      next: () => {
        if (event.payload.save) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
        } else if (event.payload.saveAndFinishLater) {
          this._snackBar.open("Saved successfully", "Close", {
            duration: 4000,
          });
          this._router.navigate(['sessionTimedOut']);
        } else {
          this.eventBus.emit(new ChangeNavigationEvent({ id: event.payload.id }));
          this._router.navigateByUrl(event.payload.nextNavLink);
        }
      },
      error: (error: any) => console.log(error)
    });
  }

  innerHTMLClick(ev: Event) {

    let className: string = (ev.target as Element).className;
    if (className == 'af-appendix-a af-ponter') {
      let mainContentElement = document.querySelector(".appendixa");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }

    if (className == 'af-appendix-b af-ponter') {
      let mainContentElement = document.querySelector(".appendixb");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }

    if (className == 'af-appendix-c af-ponter') {
      let mainContentElement = document.querySelector(".appendixc");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-annexure-1 af-ponter') {
      let mainContentElement = document.querySelector(".annexure1");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }

    if (className == 'af-annexure-2 af-ponter') {
      let mainContentElement = document.querySelector(".annexure2");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-annexure-2 af-ponter') {
      let mainContentElement = document.querySelector(".annexure2");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-english-version af-ponter') {
      let mainContentElement = document.querySelector(".engilsh_version");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-chinese-version af-ponter') {
      let mainContentElement = document.querySelector(".chinese_version");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-chinese-appendixa af-ponter') {
      let mainContentElement = document.querySelector(".chinese_appendixa");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-chinese-appendixc af-ponter') {
      let mainContentElement = document.querySelector(".chinese_appendixc");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-ous-appendix-a af-ponter') {
      let mainContentElement = document.querySelector(".ous_appendixa");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-ous-appendix-b af-ponter') {
      let mainContentElement = document.querySelector(".ous_appendixb");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-ous-appendix-c af-ponter') {
      let mainContentElement = document.querySelector(".ous_appendixc");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-ous-annexure-1 af-ponter') {
      let mainContentElement = document.querySelector(".ous_annexure1");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
    if (className == 'af-ous-annexure-2 af-ponter') {
      let mainContentElement = document.querySelector(".ous_annexure2");
      if (mainContentElement) {
        mainContentElement.scrollIntoView(true);
      }
    }
  }

  getPercentage(container: UntypedFormGroup): number {
    let errorCount = 0;
    let totalCount = 0;

    for (let controlKey in container.controls) {
      if (container.controls.hasOwnProperty(controlKey)) {
        if (container.controls[controlKey].validator != null) {
          totalCount += container.controls[controlKey].validator.length;
        }
        if (container.controls[controlKey].errors) {
          errorCount += Object.keys(container.controls[controlKey].errors).length;
        }
      }
    }

    return ((totalCount - errorCount) / totalCount) * 100;
  }

  validate() {
    this.ackData.markAllAsTouched();
    this.hasBeenSubmitted = true;

    if (!this.legalRequirementsMet.value) {
      this.legalRequirementsMet.setErrors({ invalid: true });
      this.checkTwo = true;
    }

    if (this.jobCountry !== "CHN" && !this.discTermsCheck.value) {
      this.discTermsCheck.setErrors({ invalid: true });
      this.check = true;
    }

    if (this.jobCountry === "CHN" && !this.chnCookiesDisc.value) {
      this.chnCookiesDisc.setErrors({ invalid: true });
      this.checkCHNCookies = true;
    }

    if (this.jobCountry === "CHN" && !this.chnPDDisc.value) {
      this.chnPDDisc.setErrors({ invalid: true });
      this.checkCHNPDDisc = true;
    }

    if (this.jobCountry === "CHN" && !this.chnThirdDisc.value) {
      this.chnThirdDisc.setErrors({ invalid: true });
      this.checkCHNThirdDisc = true;
    }

    if (this.jobCountry === "CHN" && !this.chnTransferDisc.value) {
      this.chnTransferDisc.setErrors({ invalid: true });
      this.checkCHNTransferDisc = true;
    }

    if (!this.output.value) {
      this.output.setErrors({ invalid: true });
    }

    if (!this.termsCheck) {
      this.pdfButtonFocus();

      return false;
    }

    if (this.ackData.invalid) {
      return false;
    }

    return true;
  }

  pdfButtonFocus(): void {
    setTimeout(() => {
      this.pdfButton.nativeElement.focus();
    });
  }

  onFocusOutMainContent() {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  print() {
    let printElement = document.getElementById('print-section') as HTMLElement;
    let printContents = printElement.innerHTML;
    let popupWin = window.open("", "_blank", "top=0,left=0,height=auto,width=auto");

    popupWin.document.open();
    popupWin.document.write("\n      <html>\n        <head>\n          <title>" + ("") + "</title>        </head>\n        <body onload=\"window.print(); setTimeout(function(){ window.close(); }, 0)\">\n          " + printContents + "\n        </body>\n      </html>");
    popupWin.document.close();
  }

  getUrl(sig: string) {
    this.signatureImg = sig; // Gets the base64 String from wet-signature @Output
    this.ackData.get('output').setValue(sig);
  }

  sigCheck(sigCheck: boolean) {
    this.sigCheckValue = sigCheck;
  }

  termsOnBlur() {
    if (this.discTermsCheck.value) {
      this.check = false;
    } else {
      this.check = true;
    }
  }

  termsOnFocus() {
    this.check = false;
  }

  chnCookiesDiscOnBlur() {
    if (this.chnCookiesDisc.value) {
      this.checkCHNCookies = false;
    } else {
      this.checkCHNCookies = true;
    }
  }

  chnCookiesDiscOnFocus() {
    this.checkCHNCookies = false;
  }

  chnPDDiscOnBlur() {
    if (this.chnPDDisc.value) {
      this.checkCHNPDDisc = false;
    } else {
      this.checkCHNPDDisc = true;
    }
  }

  chnPDDiscOnFocus() {
    this.checkCHNPDDisc = false;
  }

  chnThirdDiscOnBlur() {
    if (this.chnThirdDisc.value) {
      this.checkCHNThirdDisc = false;
    } else {
      this.checkCHNThirdDisc = true;
    }
  }

  chnThirdDiscOnFocus() {
    this.checkCHNThirdDisc = false;
  }

  chnTransferDiscOnBlur() {
    if (this.chnTransferDisc.value) {
      this.checkCHNTransferDisc = false;
    } else {
      this.checkCHNTransferDisc = true;
    }
  }

  chnTransferDiscOnFocus() {
    this.checkCHNTransferDisc = false;
  }

  legalOnBlur() {
    if (this.legalRequirementsMet.value) {
      this.checkTwo = false;
    } else {
      this.checkTwo = true;
    }
  }

  legalOnFocus() {
    this.checkTwo = false;
  }

  setDate() {
    if (this.legalRequirementsMet.value) {
      if (!this.date) {
        if (!this.afDisclosureInfo.legalRequirementCheckDate) {
          this.date = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else if (!this.afDisclosureInfo.legalRequirementCheckDate) {
      this.date = null;
    }
  }

  setTermDate() {
    if (this.discTermsCheck.value) {
      if (!this.termDate) {
        if (!this.afDisclosureInfo.discTermsCheckDate) {
          this.termDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else if (!this.afDisclosureInfo.discTermsCheckDate) {
      this.termDate = null;
    }
  }

  setTermDateCHN() {
    if (this.chnCookiesDisc.value && this.chnThirdDisc.value && this.chnThirdDisc.value && this.chnTransferDisc.value) {
      if (!this.termDate) {
        if (!this.afDisclosureInfo.discTermsCheckDate) {
          this.termDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
        }
      }
    } else if (!this.afDisclosureInfo.discTermsCheckDate) {
      this.termDate = null;
    }
  }

  scrollToAppendixA(): void {
    const fragment: string = "appendix-a";
    const element = document.getElementById(fragment);
    if (element != undefined) element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    window.scroll(0, 0);
  }

}
